<div class="ask-navi-layout">
  <an-conversation-sidebar />
  <an-ask-navi-chat
    class="ask-navi-layout__main flex h-full min-h-0 min-w-0 w-full flex-1 flex-col overflow-hidden"
  />
</div>
